import { Theme, createTheme } from "@material-ui/core/styles";

export class ThemeMuiProvider {
  public static provideTheme = (): Theme => {
    return createTheme({});
  };
}
